import { TrendingDown, Clock, Feather, Sparkles, Heart, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";
import { useQuiz } from "../../hooks/QuizContext";

const ITEMS = [
  { icon: TrendingDown, title: "Redução progressiva dos pelos", text: "Com o tempo, os pelos nascem mais finos e em menor quantidade." },
  { icon: Clock, title: "Pele lisa por mais tempo", text: "Adeus à necessidade de depilação frequente com cera ou lâmina." },
  { icon: Feather, title: "Menos irritações", text: "Evita foliculite, pelos encravados e alergias causadas por outros métodos." },
  { icon: Sparkles, title: "Pele mais uniforme", text: "Reduz manchas e deixa a pele mais bonita e saudável." },
  { icon: Heart, title: "Mais praticidade e liberdade", text: "Conforto no dia a dia, na praia, na academia e em qualquer ocasião." },
];

const Card = ({ item, i }) => {
  const Icon = item.icon;
  return (
    <Reveal delay={0.06 * i} className="bento-card group" data-testid={`benefit-card-${i + 1}`}>
      <span className="icon-circle transition-transform duration-500 group-hover:-rotate-12 group-hover:scale-110">
        <Icon className="h-6 w-6" aria-hidden="true" />
      </span>
      <h3 className="mt-8 font-display text-xl leading-tight tracking-tight text-[#2D1C18]">{item.title}</h3>
      <p className="mt-3 text-[0.95rem] leading-relaxed text-[#6B5650]">{item.text}</p>
    </Reveal>
  );
};

const BenefitsCta = () => {
  const { openQuiz } = useQuiz();
  return (
    <Reveal delay={0.3}>
      <button
        type="button"
        onClick={() => openQuiz("benefits")}
        className="bento-cta group text-left w-full cursor-pointer"
        data-testid="benefits-cta-whatsapp"
      >
        <span className="font-display text-2xl leading-tight">Comece sua<br />transformação</span>
        <span className="flex items-center justify-between text-sm font-semibold tracking-[0.18em]">
          AGENDAR NO WHATSAPP
          <ArrowUpRight className="h-6 w-6 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1" aria-hidden="true" />
        </span>
      </button>
    </Reveal>
  );
};

export const Benefits = () => (
  <section id="beneficios" className="relative py-24 sm:py-32" aria-labelledby="beneficios-title" data-testid="benefits-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="mb-14 grid gap-6 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Eyebrow className="text-[#9A4A38]">Benefícios da</Eyebrow>
          <h2 id="beneficios-title" className="section-title mt-4">
            Depilação <span className="text-metal">a laser</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-[#6B5650] sm:text-lg">
            Muito além de tirar pelos: é ganhar tempo, conforto e liberdade para viver cada dia com mais confiança.
          </p>
        </Reveal>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-3">
        <Reveal className="relative min-h-[420px] overflow-hidden rounded-[1.75rem] md:col-span-2 lg:col-span-1 lg:row-span-3" y={50}>
          <img src="/img/legs.webp" alt="Pernas lisas e hidratadas sobre lençóis de cetim" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.8s] hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#2D1C18]/75 via-transparent to-transparent" aria-hidden="true" />
          <p className="absolute bottom-6 left-6 right-6 font-script text-5xl leading-none text-[#FAF5EE]">liberdade<br />todo dia</p>
        </Reveal>
        {ITEMS.map((item, i) => <Card key={item.title} item={item} i={i} />)}
        <BenefitsCta />
      </div>
    </div>
  </section>
);

